import features from 'lib/common/features';
import { find } from 'lodash';

export function cartContainsRestrictedTickets(lineItems) {
  if (features.isEnabled('ticketRestrictions') === false) {
    return false;
  }

  let restrictedSeatTypes = features.getOption(
    'ticketRestrictions',
    'restrictions'
  );

  let errors = [];

  lineItems.forEach(item => {
    // Get the restriction for this item
    const restriction = find(restrictedSeatTypes, o => {
      return o.restrictedHoldCodes.indexOf(item.seatData.hc_no) !== -1;
    });

    if (restriction) {
      // See if we can fulfill this one
      let fulfillingLineItem = find(lineItems, o => {
        return restriction.dependsOn.indexOf(o.seatData.hc_no) !== -1;
      });

      if (fulfillingLineItem === undefined) {
        errors.push(restriction.errorMessage);
      }
    }
  });

  if (errors.length > 0) {
    return errors;
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/cart/ticketRestrictions.js